export const tagList = [
    "Home",
    "Trip Start",
    "Trip End",
    "Trip Terminus",
    "Toll Plaza",
    "Toll Gate",
    "Parking",
    "Loading",
    "Unloading",
    "Dhaba",
    "Truck Terminal",
    "Petrol Pump",
    "Weigh Bridge",
    "Service Center",
    "Other"
];